import commonData from './commonData';
import pageData from './pageData';
import params from './params';

export const reducer = {
    commonData,
    pageData,
    params
};